<!-- TEXTBOX -->
@if (entry.base?.display && !entry.base?.foreverHidden) {
  <form [connect]="'payloadStates.' + entry?.formControlAttributes?.connectPath"
    class="question-class"
    [formGroup]="form"
    >
    <mat-form-field appearance="outline">
      <mat-label>{{entry?.formControlAttributes?.label}}</mat-label>
      <input matInput
        #entryRef
        placeholder="{{entry.inputAttributes?.placeholder || '01/01/1970'}}"
        [matDatepicker]="picker"
        [formControlName]="entry?.formControlAttributes?.formControlName"
        [name]="entry?.formControlAttributes?.formControlName"
        [id]="entry?.formControlAttributes?.formControlName"
        [min]="dateRange?.min"
        [max]="dateRange?.max"
        [required]="valueRequired" />
        <mat-datepicker-toggle
          [hidden]="entry?.inputAttributes?.hideDatepicker"
          matSuffix
          [for]="picker">
        </mat-datepicker-toggle>
        <mat-datepicker
          #picker
        startView='multi-year'></mat-datepicker>
        @if (formControls[entry?.formControlAttributes?.formControlName]?.errors) {
          <mat-error>
            @if (formControls[entry?.formControlAttributes?.formControlName]?.errors.required) {
              <span>
                Required
              </span>
            }
            @if (formControls[entry?.formControlAttributes?.formControlName]?.errors.matDatepickerMin) {
              <span>
                Date must be on or after {{dateRange.minErrorFormat}}
              </span>
            }
            @if (formControls[entry?.formControlAttributes?.formControlName]?.errors.matDatepickerMax) {
              <span>
                Date must be on or before {{dateRange.maxErrorFormat}}
              </span>
            }
            @if (formControls[entry?.formControlAttributes?.formControlName]?.errors.matDatepickerMinDob) {
              <span>
                Date must be on or after your Date Of Birth
              </span>
            }
          </mat-error>
        }
      </mat-form-field>
      @if (isOkToDisplayAgeInfo && form.get(entry?.formControlAttributes?.formControlName)?.value && !formControls[entry?.formControlAttributes?.formControlName]?.errors) {
        <div class="age-display">{{ displayDateOfBirth(form.get(entry?.formControlAttributes?.formControlName)?.value) }} years old as of {{ formatEffDate }}</div>
      }
    </form>
  }